import { Map, List, fromJS } from 'immutable'
import Moment from 'moment'

import {
  INITIAL_SET_DATES,
  SET_DATES,
  SET_INVITES,
  SET_WEEK,
  JOIN_SESSION,
  JOINING,
  JOIN_ERROR,
  CLEAR_JOIN_ERROR,
  LEAVE_SESSION
} from './actions'
import { formatYearAndWeek } from '../../../services/utils'

// const start = Moment('2018-03-01T18:00:00Z').format('YYYY-WW')
const start = formatYearAndWeek(Moment())

const initialState = new Map({
  dates: new List(),
  week: start,
  start_week: start,
  invites: new Map(),
  last_week: null,
  finished: false,
  loaded: false,
  error: null
})

let indexOfListToUpdate = null

const sessionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIAL_SET_DATES:
      return state
        .set('dates', fromJS(action.data.sessions))
        .set('finished', action.data.finished)
        .set('offset', action.data.offset)
        .set('last_week', action.data.last_week)
        .set('loaded', true)

    case SET_DATES:
      return state
        .update('dates', dates => dates.concat(fromJS(action.data.sessions)))
        .set('finished', action.data.finished)
        .set('offset', action.data.offset)
        .set('last_week', action.data.last_week)
        .set('loaded', true)

    case SET_WEEK:
      return state.set('week', action.data)

    case SET_INVITES:
      return state.set('invites', fromJS(action.data))

    case JOINING:
      return state.set('joining', action.data)

    case JOIN_SESSION:
      indexOfListToUpdate = state
        .get('dates')
        .findIndex(session => session.get('id') === action.data.id)
      return state.setIn(['dates', indexOfListToUpdate], fromJS(action.data))

    case JOIN_ERROR:
      return state.set('error', action.data).set('joining', false)

    case CLEAR_JOIN_ERROR:
      return state.set('error', null)

    case LEAVE_SESSION:
      indexOfListToUpdate = state
        .get('dates')
        .findIndex(session => session.get('id') === action.data.id)
      return state
        .setIn(['dates', indexOfListToUpdate], fromJS(action.data))
        .set('invites', new Map())

    default:
      return state
  }
}

export default sessionsReducer
